'use client';
import ButtonsHideAmount from '@components/buttons-hide-amount/ButtonsHideAmount';
import Switch from '@components/switch/Switch';
import lockIcon from '@images/renders/icon_images/icon-lock.svg';
import { FINCH_FLAT_FORMA_31908, RESERVED_FLATS_31832, SETTLEMENT_INFO_29919 } from '@lib/flags';
import { handleChangeFormName, handleOpenModelForm } from '@lib/store/slices/ComponentsSlice';
import { setFlatInfo } from '@lib/store/slices/FlatSlice';
import changeDate from '@lib/tools/_change_date';
import changeEnding from '@lib/tools/_change-ending';
import editRoomsLabel from '@lib/tools/_edit-rooms-label';
import getReservedSimilarParams from '@lib/tools/_get_reserved_similar_params';
import cn from 'classnames';
import DOMPurify from 'isomorphic-dompurify';
import NextImage from 'next/image';
import { memo, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Equalizer from '../equalizer/Equalizer';
import FlatBookButton from '../flat-block-button/FlatBookButton';
import PriceBlock from '../price-block/PriceBlock';
import style from './FlatInfoDescription.module.scss';

const FlatInfoDescription = memo(({ flat }) => {
  const dispatch = useDispatch();
  const allFlats = useSelector(state => state?.filters?.flats);

  const rooms = editRoomsLabel(flat);
  const isReserved = flat.status === 'reserve' && RESERVED_FLATS_31832;

  const similarFlatsHref = getReservedSimilarParams(allFlats, flat);

  const handleOpenForm = () => {
    dispatch(handleOpenModelForm(true));
    dispatch(handleChangeFormName('flatForm'));
  };

  useEffect(() => {
    dispatch(setFlatInfo(flat));
  }, []);

  return (
    <div className={style.flatDescription}>
      <div className={cn({ [style.flatDescription__info]: isReserved })}>
        {rooms?.rooms === 'Студия' ? (
          <p className={style.flatDescription__title} itemProp='name'>
            {rooms?.rooms} {flat?.area}
            <span>
              м<sup>2</sup>
            </span>
          </p>
        ) : (
          <p className={style.flatDescription__title} itemProp='name'>
            {rooms?.rooms} {changeEnding('bedroom', rooms?.rooms)}, {flat?.area}
            <span>
              м<sup>2</sup>
            </span>
          </p>
        )}

        <div className={style.flatDescription__box} itemProp='description'>
          <p className={style.flatDescription__desc_text}>{flat?.bulk?.name}</p>
          <p className={style.flatDescription__desc_text}>
            {flat?.floor} этаж из {flat?.section?.floorsCount}
          </p>
          <p className={style.flatDescription__desc_text}>
            <span>№</span> {flat?.number}
          </p>
        </div>
        {!SETTLEMENT_INFO_29919 && (
          <p className={style.flatDescription__deadline}>{changeDate(flat?.bulk?.settlement_date)}</p>
        )}
        <p className={style.flatDescription__deadline}>{changeDate(flat?.bulk?.keyDate, 'Выдача ключей до')}</p>
        <div className={style.flatDescription__speacials}>
          {flat && <ButtonsHideAmount info={true} flat={flat} amount={1000} />}
        </div>
      </div>

      {isReserved ? (
        <div className={style.reservedBlock}>
          <div className={style.reservedBlock__lockImg}>
            <NextImage width={18} height={18} className={style.reservedBlock__lockImg_icon} src={lockIcon} alt='lock' />
          </div>
          <p className={style.reservedBlock__title}>Квартира забронирована</p>
          <p
            className={style.reservedBlock__description}
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(
                'Посмотрите похожие варианты или подпишитесь<br/> на&nbsp;эту квартиру&nbsp;&mdash; уведомим вас если квартира освободится.',
              ),
            }}
          />
          <div className={style.reservedBlock__buttons}>
            <Switch
              handleSwitch={() => {
                dispatch(handleChangeFormName('reserveFlatForm'));
                dispatch(handleOpenModelForm(true));
              }}
              switchText='Подписаться'
              testId='flatReservedFormOpen'
              black
              flat={flat}
              someStyles={style.reservedBlock__buttons_btn}
            />
            <Switch
              switchText='похожие квартиры'
              testId='sameFlatsButton'
              type='link'
              href={similarFlatsHref}
              target='_self'
              someStyles={style.reservedBlock__buttons_btn}
            />
          </div>
        </div>
      ) : (
        <>
          {/* Новая логика эквалайзера */}
          <Equalizer flat={flat} />
          {!FINCH_FLAT_FORMA_31908 && <FlatBookButton flat={flat} switchText='Оставить заявку' />}
          {FINCH_FLAT_FORMA_31908 && (
            <div className={style.flatDescription__booking}>
              <PriceBlock flat={flat} />
              <Switch handleSwitch={handleOpenForm} switchText='ОСТАВИТЬ ЗАЯВКУ' black testId='mortgageFormOpen' />
              <Switch switchText='Рассчитать ипотеку' type='link' href='#calc' target='_self' />
            </div>
          )}
        </>
      )}
    </div>
  );
});

export default FlatInfoDescription;
